import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Strip } from "./Strip";
import { searchPrint } from "../../util/sort";
import { useSearch } from "../../context/SearchContext";
import { FABRIC_BG } from "../../util/tableRip";
import { StripNone } from "./StripNone";
import { FabricTimer } from "../common/FabricTimer";

export const PrintList = () => {
  const { printFile, loading } = useSelector((state) => state.printFile);
  const { searchQuery } = useSearch();
  const [runningTimers, setRunningTimers] = useState({})
  
  let displayFiles = [];
  displayFiles = searchQuery
    ? searchPrint(printFile, searchQuery)
    : printFile || [];

  return (
    <React.Fragment>
      <div className="flex flex-col w-[100%] mx-auto py-4">
        <div className="flex flex-row  w-[100%] my-4 text-center text-[#9E9E9E] text-[1vw] mx-auto ">
          <div className="h-[5px] w-[11.36%] content-center">data</div>
          <div className="h-[5px] w-[11.36%] content-center">folder</div>
          <div className="h-[5px] w-[16.41%] content-center">team members</div>
          <div className="h-[5px] w-[19.19%] content-center">order</div>
          <div className="h-[5px] w-[31.57%] content-center">file name</div>
          <div className="h-[5px] w-[10.10%] content-center ">finish</div>
        </div>
        {displayFiles.length === 0 && <StripNone />}
        {displayFiles &&
          displayFiles.map((i, key) => (
            <React.Fragment key={key}>
              <div className="flex flex-row justify-between w-[100%]">
                <div
                  className={`w-[11.45%] flex justify-left  rounded-t-xl mt-4 mb-1 h-[40px] py-2 ${
                    Object.keys(FABRIC_BG).find((key) =>
                      i.folderFabric.toUpperCase().includes(key),
                    )
                      ? FABRIC_BG[
                          Object.keys(FABRIC_BG).find((key) =>
                            i.folderFabric.toUpperCase().includes(key),
                          )
                        ]
                      : ""
                  }`}
                >
                  <p
                    className=" my-auto font-bold m-3 w-[33%] text-left "
                    style={{ textTransform: "uppercase" }}
                  >
                    {loading && i.folderFabric}
                  </p>
                </div>
                {/* ----------------------------------------Счетчик времени печати на ткани -------------------------------------------- */}
                {/* <div className={`w-[10.25%] flex items-center justify-center rounded-t-xl mt-4 mb-1 h-[40px] py-2 font-bold text-white transition-colors duration-300 ${
                  runningTimers[`fabric_${i.folderFabric}`] ? 'bg-[#FF3D00]' : 'bg-[#739D00]'
                }`}>
                  <FabricTimer 
                    fabric={i.folderFabric} 
                    rip={i} 
                    id={`fabric_${i.folderFabric}`}
                    onRunningChange={(isRunning) => {
                      setRunningTimers(prev => ({
                        ...prev,
                        [`fabric_${i.folderFabric}`]: isRunning
                      }))
                    }}
                  />
                </div> */}
              </div>
              <Strip i={i} key={key} color={i.folderFabric} />
            </React.Fragment>
          ))}
      </div>
    </React.Fragment>
  );
};
